"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_NUMERACION = exports.VALIDAR_PORTABILIDAD_NUMERACION = void 0;
exports.VALIDAR_PORTABILIDAD_NUMERACION = {
    PENDIENTE: 0,
    VALIDADO: 1,
};
exports.ESTATUS_NUMERACION = {
    BAJA: 0,
    DISPONIBLE: 1,
    ASIGNADO: 2,
    RESERVADO: 3,
    MARCADO: 4,
    PORTADO: 5,
};
